const forms = document.querySelectorAll('form[data-block-common-email-domains]');

class BlockCommonEmailDomains {
    constructor(form) {
        this.form = form;

		boundValidateEmailField = this.validateEmailField.bind(this);

		this.form.querySelectorAll('input[type="email"]').forEach(function(emailInput) {
			emailInput.addEventListener('input', boundValidateEmailField);

		});

        this.blockedEmailDomains = [
            "gmail",
            "gmx",
            "hotmail",
            "freenet",
            "web",
            "yahoo",
            "outlook",
            "mail",
            "icloud",
            "t-online",
        ];
    }

    validateEmailField(e) {
		if (this.isBlockedEmailDomain(e.target.value)) {
			e.target.parentNode.querySelector('[data-block-email-domains-errormsg]').classList.remove('hidden');
			this.form.querySelector('button[type=submit]').disabled = true;

		} else {
			e.target.parentNode.querySelector('[data-block-email-domains-errormsg]').classList.add('hidden');
			this.form.querySelector('button[type=submit]').disabled = false;
		}
    }
  
    isBlockedEmailDomain(email) {
        const domain = email.split('@')[1];
        const regexPattern = this.blockedEmailDomains.map(blockedDomain => `^${blockedDomain.replace(/\./g, "\\.")}\\.`).join('|');
        const domainRegex = new RegExp(regexPattern, 'i');
        return domainRegex.test(domain);
    }

    createRegex() {
        return new RegExp(this.blockedEmailDomains.join('|'), 'i');
    }
}

if (forms.length > 0) {
    forms.forEach((form) => {
        new BlockCommonEmailDomains(form);
    });
}
